import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BadgeColor, DesignAngularKitModule } from 'design-angular-kit';
import { RequestDto } from '../../../../models/request.dto';
import { RouterModule } from '@angular/router';
import { getBadgeType } from '../../../../models/request.util';

@Component({
  selector: 'app-own-requests',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, RouterModule],
  templateUrl: './own-requests.component.html',
  styleUrl: './own-requests.component.scss'
})
export class OwnRequestsComponent {
  @Input() ownRequest?: RequestDto[];

  getBadgeColor(code: string): BadgeColor {
    return getBadgeType(code);
  }
}
